import * as React from 'react';
import { SVGProps } from 'react';

const CalendarArrowLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={10}
    height={16}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M.494 8.03a1.487 1.487 0 0 0 .435 1.06l6 5.971a1.508 1.508 0 0 0 1.641.325 1.507 1.507 0 0 0 .815-.811 1.492 1.492 0 0 0-.326-1.634L4.094 8.03l4.77-4.926a1.493 1.493 0 0 0 .381-1.685A1.493 1.493 0 0 0 8.38.592a1.507 1.507 0 0 0-1.675.45L.914 7.015a1.49 1.49 0 0 0-.42 1.015Z"
      fill="#569DE5"
    />
  </svg>
);

export default CalendarArrowLeft;
